const LEGACY_ARTICLE_BLOCKS = [
  { type: 'post_texts', collection: 'post_texts', idKey: 'textId' },
  { type: 'post_pictures', collection: 'post_pictures', idKey: 'groupId' },
  { type: 'post_artworks', collection: 'post_artworks', idKey: 'groupId' },
  { type: 'post_videos', collection: 'post_videos', idKey: 'groupId' },
  { type: 'post_polls', collection: 'post_polls', idKey: 'pollId' },
  { type: 'post_quizzes', collection: 'post_quizzes', idKey: 'quizId' },
];

const toArray = value => Array.isArray(value) ? value : [];

function buildLegacyArticleStructure(content) {
  return LEGACY_ARTICLE_BLOCKS.flatMap(({ type, collection, idKey }) =>
    toArray(content[collection]).flatMap(block => {
      const id = Number(block?.[idKey]);
      return Number.isInteger(id) ? [{ type, id }] : [];
    })
  );
}

/**
 * Hydrates an article's block data without changing its authored order.
 *
 * Older records without a structure receive a deterministic fallback. Newer
 * records always retain their persisted structure, including block types that
 * the editor does not currently render.
 */
export function hydrateArticleContent(container) {
  const content = container || {};
  const hasSavedStructure = Array.isArray(content.post_structure)
    && content.post_structure.length > 0;
  const hasBlockData = LEGACY_ARTICLE_BLOCKS.some(({ collection }) =>
    toArray(content[collection]).length > 0
  );

  return {
    post_structure: hasSavedStructure
      ? content.post_structure.map(block => ({ ...block }))
      : hasBlockData
        ? buildLegacyArticleStructure(content)
        : [],
    post_texts: toArray(content.post_texts),
    post_pictures: toArray(content.post_pictures),
    post_artworks: toArray(content.post_artworks),
    post_videos: toArray(content.post_videos),
    post_polls: toArray(content.post_polls),
    post_quizzes: toArray(content.post_quizzes),
  };
}
